import getScrollDistance from 'bundles/cds-labs/components/OverflowCarousel/getScrollDistance';

const scrollToNext = ({
  carouselRefCurrent,
  itemsOffset,
  isRightToLeft = false,
  offset,
}: {
  carouselRefCurrent: HTMLDivElement;
  itemsOffset: Map<string, { offsetLeft: number; offsetWidth: number }>;
  isRightToLeft?: boolean;
  offset: number;
}) => {
  if (!carouselRefCurrent) {
    return;
  }

  const iterator = itemsOffset?.entries();
  let currentEntry = iterator?.next();

  const threshold = Math.abs(carouselRefCurrent.scrollLeft) + carouselRefCurrent.offsetWidth;

  // Find the item that is the closest to the right of the visible area and scroll to it.
  while (!currentEntry?.done) {
    const [, value] = currentEntry?.value;
    const nextEntry = iterator?.next();

    const scrollDistance = getScrollDistance({
      value,
      isRightToLeft,
      carouselRefCurrent,
      offset,
    });

    if (
      scrollDistance <= threshold &&
      (nextEntry?.done ||
        getScrollDistance({
          value: nextEntry?.value?.[1],
          isRightToLeft,
          carouselRefCurrent,
          offset,
        }) > threshold)
    ) {
      carouselRefCurrent.scrollTo({
        left: isRightToLeft ? -scrollDistance : scrollDistance,
        behavior: 'smooth',
      });
      return;
    }
    currentEntry = nextEntry;
  }
};

export default scrollToNext;
